// Copyright © 2015-2020 TrampleZone LLC All Rights Reserved

// Server Module

// Single exposed XHR interface between client and server

define('Server',['require','Utilities'],function (require) {
    'use strict';

    var // Require.js module dependencies
        Utilities = require('Utilities'),

        // The target server for this client (ONLY CHANGE THIS LINE TO SELECT ONE)
        target = 'master', // Must be local | $DEV | dev | test | demo | master

        // Servlet names
        serverName      = 'SizzleScene',
        lowerServerName = serverName.toLowerCase(),
        servletName     = 'MainServlet',
        myDevMachineIP  = 'localhost',

        // Server connection details (local, dev, master, $DEV...)
        serverDomain,       // Domain (document.domain | IP | $app.com)
        serverPort,         // Port number on the server
        directory,          // Mount point for app on app server

        // Master and Dev server URL components
        masterDomain    = lowerServerName + '.com',
        masterDirectory = lowerServerName + 'server',
        devDomain       = 'dev.' + lowerServerName + '.com',
        devDirectory    = lowerServerName + 'server-dev',

        // Instance variables
        utilities;

    // Constructor
    function Server () {
        // Dependent Resources
        utilities = new Utilities();

        // Decide the target server to which to connect this client
        switch (target) {

            case 'local':    // (change myDevMachineIP if needed)
                serverDomain = document.domain || myDevMachineIP;
                serverPort   = '8443';
                directory    = serverName + 'Server';
                break;

            case 'master':
                serverDomain = masterDomain;
                serverPort   = this.getServerPort();
                directory    = masterDirectory;
                break;

            default:
                serverDomain = devDomain;
                serverPort   = this.getServerPort();
                directory    = devDirectory;
                break;
        };
    };

    // Return the document root for the desired server
    Server.prototype.getDocumentRoot = function () {
        // Special case for Android emulator
        if (utilities.isAndroidEmulator() && serverDomain === myDevMachineIP) {
            serverDomain = '10.0.2.2';  // Proxy for running server on localhost
        }
        // Construct the URL and return
        return this.getServerURL() + (directory ? '/' + directory : '');
    };

    // Return the URL to the desired server servlet for this client
    Server.prototype.getServletURL = function () {
        return this.getDocumentRoot() + '/' + servletName;
    };

    // Return the base URL to the desired server for this client
    Server.prototype.getServerURL = function () {
        return 'https://' + serverDomain + ':' + serverPort;
    };

    // Get the master server URL
    Server.prototype.getMasterServerURL = function () {
        return 'https://' + masterDomain + ':' + this.getServerPort() +
            (masterDirectory ? '/' + masterDirectory : '');
    };

    // Get the development server URL
    Server.prototype.getDevelopmentServerURL = function () {
        return 'https://' + devDomain + ':' + this.getServerPort() +
            (devDirectory ? '/' + devDirectory : '');
    };

    // Get proper server port based on platform and version
    Server.prototype.getServerPort = function () {
        if (serverPort == null || typeof serverPort == 'undefined') {
            serverPort = '443';
            // Check for old Android versions and divert to non-ATS port
            if (utilities.isAndroid()) {
                var androidVersionString = utilities.getAndroidVersion();
                if (androidVersionString.match(/[0-9\.]+/g)) {
                    var digits = androidVersionString.split('.');
                    var baseVersionNumber = digits[0];
                    if (digits.length > 0) {
                        baseVersionNumber += '.' + digits[1];
                    }
                    var androidVersionNumber = parseFloat(baseVersionNumber);
                    if (androidVersionNumber && androidVersionNumber < 4.4) {
                        serverPort = '8443';
                    }
                }
            }
        }
        return serverPort;
    };

    // Process client request
    Server.prototype.submit = function(data, timeout, callback) {
        // Get the server URI
        var server = this.getServletURL();

        // Create a new XHR request
        var request = new XMLHttpRequest();

        // Prepare query string
        var queryString = 'request_data=' + JSON.stringify(data);

        // Set a timeout, if requested
        var xhrTimeout;
        if (timeout) {
            xhrTimeout = setTimeout(function() {
                // Abort request as it timed out
                request.abort();
                if (callback) {
                    callback({timeout: true});
                }
            }, timeout);
        }

        // Setup callback if specified, otherwise don't bother
        if (callback) {
            request.onreadystatechange = function () {
                if (request.readyState == 4 && (request.status == 200)) {
                    clearTimeout(xhrTimeout);
                    if (callback) {
                        if (request.responseText &&
                            request.responseText.length > 0) {
                            callback(JSON.parse(request.responseText));
                        } else {
                            // No timeout, but no response either
                            callback({failed: true});
                        }
                    }
                }
            };
        }

        // Submit
        request.open('POST', server, true);
        request.setRequestHeader('X-Alt-Referer', server + '/');
        request.setRequestHeader('Content-type',
                                 'application/x-www-form-urlencoded; charset=UTF-8');
        request.send(queryString);
    };

    // Return Constructor
    return Server.prototype.constructor;
});

